import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useFirebase from '../../../../../useFirebase';
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import { setShowMessage } from "../../../AxiosRtk/successMessage";

const Nudity = ({ deviceSelected, getLangTranslation }) => {
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(true); // Initially disabled
    const [nudityImageCategorization, setNudityImageCategorization] = useState({
        onlyNudityEnable: 0,
        detectAllNudityEnable: 0,
        deleteNudePicEnable: 0,
        screenshotNudityEnable: 0,
        blockSourceNudityEnable: 0
    });

    const [originalNudityImageCategorization, setOriginalNudityImageCategorization] = useState({});

    const {
        postCollectionData,
        createCollectionData,
        getCollectionData
    } = useFirebase();

    const {
        setRulesData
    } = useSelector(({ setRules }) => setRules);

    function callFireStore(payload) {
        if (setRulesData) {
            postCollectionData(deviceSelected, payload)
        } else {
            createCollectionData(deviceSelected, payload)
        }
        getCollectionData(deviceSelected);
    }

    function handleInputChange(e) {
        const { name, checked } = e.target;

        if (name === 'ENABLE_NUDITY_ONLY') {
            setNudityImageCategorization({
                ...nudityImageCategorization,
                onlyNudityEnable: checked ? 1 : 0
            });
        } else if (name === 'DETECT_ALL') {
            setNudityImageCategorization({
                ...nudityImageCategorization,
                detectAllNudityEnable: checked ? 1 : 0
            });
        } else if (name === 'DELETE_NUDITY_PIC') {
            setNudityImageCategorization({
                ...nudityImageCategorization,
                deleteNudePicEnable: checked ? 1 : 0
            });
        } else if (name === 'DETECT_NUDITY') {
            setNudityImageCategorization({
                ...nudityImageCategorization,
                screenshotNudityEnable: checked ? 1 : 0
            });
        } else if (name === 'BLOCK_SOURCE_APP') {
            setNudityImageCategorization({
                ...nudityImageCategorization,
                blockSourceNudityEnable: checked ? 1 : 0
            });
        }
    }

    useEffect(() => {
        if (deviceSelected) {
            getCollectionData(deviceSelected);
        } else {
            dispatch(setRuleDataSetUp(null));
        }
    }, [deviceSelected]);

    useEffect(() => {
        if (setRulesData) {
            setNudityImageCategorization(setRulesData?.nudityimagecategorization);
            setOriginalNudityImageCategorization(setRulesData?.nudityimagecategorization);
        } else {
            setNudityImageCategorization({
                onlyNudityEnable: 0,
                detectAllNudityEnable: 0,
                deleteNudePicEnable: 0,
                screenshotNudityEnable: 0,
                blockSourceNudityEnable: 0
            });
            setOriginalNudityImageCategorization({
                onlyNudityEnable: 0,
                detectAllNudityEnable: 0,
                deleteNudePicEnable: 0,
                screenshotNudityEnable: 0,
                blockSourceNudityEnable: 0
            });
        }
    }, [setRulesData]);

    // Compare current state with original state to enable/disable Save
    useEffect(() => {
        const isChanged = JSON.stringify(nudityImageCategorization) !== JSON.stringify(originalNudityImageCategorization);
        setIsDisabled(!isChanged); // Enable Save button if there are changes
    }, [nudityImageCategorization, originalNudityImageCategorization]);

    function handleSave() {
        setIsDisabled(true);
        const collectionPayload = {
            setRulesActiveInActiveStatus: { ...setRulesData?.setRulesActiveInActiveStatus, nudityAndImageCategorizationEnabled: nudityImageCategorization?.onlyNudityEnable ? true : false },
            nudityimagecategorization: { ...nudityImageCategorization }
        }

        // console.log(collectionPayload)
        callFireStore(collectionPayload);
        setTimeout(() => {
            setIsDisabled(false);
            dispatch(setShowMessage({
                showMessage: true,
                defaultMessage: "Data saved successfully",
                message: "DATA_SAVED",
            }))
        }, 1000);
    }

    if (!deviceSelected) {
        return (
            <div className='text-center my-3'>
                -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
            </div>
        )
    }

    return (
        <>
            <div className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
                <i className='icon-info-one fs-5' />
                {getLangTranslation("NUDITY_AND_IMAGE_DESC", "By enabling this feature, you will be able to detect any picture on your child's device which contains nudity content")}
                {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
            </div>
            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
                <i className='icon-info-one fs-5' />
                {getLangTranslation("NUDITY_AND_IMAGE_DETECT_DESCLAIMER", "Our image recognition is a good tool. However, be aware of the results. In some cases the result shown is incorrect. It is only for reference.")}
                {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
            </div>
            <div className="d-flex align-items-center gap-3 mb-4">
                <div className={`form-check form-switch ${lang?.isRTL === 1 ? 'ms-auto' : 'me-auto'}`}>
                    <input
                        className="form-check-input mt-3"
                        id='ENABLE_NUDITY_ONLY'
                        type="checkbox"
                        role="switch"
                        name='ENABLE_NUDITY_ONLY'
                        checked={nudityImageCategorization?.onlyNudityEnable ?? 0}
                        onChange={handleInputChange}
                    />
                    <label className="form-check-label" htmlFor="ENABLE_NUDITY_ONLY">
                        <span className='text-blue-800 fw-semibold '>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_NUDITY_ONLY", "Detect Nudity only")}</span>
                        <p className='text-small mb-0'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_NUDITY_ONLY_DESC", "This option will detect only Nudity content in images and videos.")}</p>
                    </label>
                </div>
                <button className="btn btn-primary" onClick={handleSave} disabled={isDisabled}>
                    <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
                </button>
            </div>
            <div className="form-check form-switch mb-4">
                <input
                    className="form-check-input mt-3"
                    id='DETECT_ALL'
                    name='DETECT_ALL'
                    type="checkbox"
                    role="switch"
                    checked={nudityImageCategorization?.detectAllNudityEnable ?? 0}
                    onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="DETECT_ALL">
                    <span className='text-dark fw-semibold'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_ALL", "Detect All")}</span>
                    <p className='text-small mb-0'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_ALL_DESC", "This option will detect all kind of categories: Nudity, Violence, Drugs, etc..")}</p>
                </label>
            </div>
            <div className="form-check form-switch mb-4">
                <input
                    className="form-check-input mt-3"
                    id='DELETE_NUDITY_PIC'
                    name='DELETE_NUDITY_PIC'
                    type="checkbox"
                    role="switch"
                    checked={nudityImageCategorization?.deleteNudePicEnable ?? 0}
                    onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="DELETE_NUDITY_PIC">
                    <span className='text-dark fw-semibold'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_ON_CHILD_DEVICE", "Delete Nudity pictures once detected on child’s device")}</span>
                    <p className='text-small mb-0'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_ON_CHILD_DEVICE_DESC", "This option will auto delete any Nudity picture or video detected from child’s device.")}</p>
                </label>
            </div>
            <div className="form-check form-switch mb-4">
                <input
                    className="form-check-input mt-3"
                    id='DETECT_NUDITY'
                    name='DETECT_NUDITY'
                    type="checkbox"
                    role="switch"
                    checked={nudityImageCategorization?.screenshotNudityEnable ?? 0}
                    onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="DETECT_NUDITY">
                    <span className='text-dark fw-semibold'>{getLangTranslation("NUDITY_AND_IMAGE_DETECT_ON_SCREENSHOT", "Detect Nudity and other image categories on screenshot pictures")}</span>
                    <p className='text-small mb-0'>{getLangTranslation("NUDITY_AND_IMAGE_DELETE_ON_SCREENSHOT_DESC", "If you enabled screenshot feature, this option will allow you to detect Nudity or any category on these screenshot.")}</p>
                </label>
            </div>
            <div className="form-check form-switch">
                <input
                    className="form-check-input mt-3"
                    id='BLOCK_SOURCE_APP'
                    name='BLOCK_SOURCE_APP'
                    type="checkbox"
                    role="switch"
                    checked={nudityImageCategorization?.blockSourceNudityEnable ?? 0}
                    onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="BLOCK_SOURCE_APP">
                    <span className='text-dark fw-semibold'>{getLangTranslation("NUDITY_AND_IMAGE_BLOCK", "Block source app of the nudity")}</span>
                    <p className='text-small mb-0'>{getLangTranslation("NUDITY_AND_IMAGE_BLOCK_DESC", "This option will auto block the app source of the Nudity picture.")}</p>
                </label>
            </div>
        </>
    );
}

export default Nudity;
